import React, { useEffect, useState } from 'react'
import { Paper } from '@mui/material';
import api from '../../API/api';


const DashBoardUpdates = () => {

    const [count, setCount] = useState();

    useEffect(() => {
        api.count().then((res) => {
            // console.log("re", res);
            setCount(res.data)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }, [])

    return (
        <Paper>
            <div className='p-3'>
                <div className='row row-gap-3'>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Total Schools</h4>
                                <h3>{count && count.tot_schools} </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Total Students</h4>
                                <h3>{count && count.tot_students} </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Total Applications</h4>
                                <h3>{count && count.tot_applications}  </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Total Blogs</h4>
                                <h3>{count && count.tot_blogs} </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Events</h4>
                                <h3>{count && count.tot_events} </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Hiring CV's</h4>
                                <h3>{count && count.tot_hiring} </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Job Applies</h4>
                                <h3>{count && count.tot_job_applies} </h3>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-3 '>
                        <Paper elevation={3}>
                            <div className='dashboardStats' >
                                <h4 className='text-primary'>Ragging Forms</h4>
                                <h3>{count && count.tot_ragging} </h3>
                            </div>
                        </Paper>
                    </div>
                </div>

                <div className='mt-3'>
                    <img src="/assets/banner/admin.jpg" className='col-12' alt="admin banner" />
                </div>
            </div>
        </Paper>
    )
}

export default DashBoardUpdates;